import * as React from "react";
import { FlexBox } from "../core/core-widgets/boxes/FlexBox/FlexBox";
import { FlexAlignItems } from "../core/core-widgets/boxes/FlexBox/types";
import "./AltitudeRangeModifier.css";
import { DelimitedSection } from "../core/core-widgets/surfaces/DelimitedSection/DelimitedSection";

export enum UnitsOfMeasurement {
    METRE = "m",
    FEAT = "ft",
}

export interface AltitudeRangeModifierStateProps {
    lowerLimit: number;
    upperLimit: number;
    units: UnitsOfMeasurement;
}
export interface AltitudeRangeModifierDispatchProps {
    onChangeMinValue: (value: number) => void;
    onChangeMaxValue: (value: number) => void;
    onChangeUnits: (value: UnitsOfMeasurement) => void;
}
const AltitudeRangeModifier = (props: AltitudeRangeModifierDispatchProps & AltitudeRangeModifierStateProps) => {
    const { onChangeMinValue, onChangeMaxValue, onChangeUnits, lowerLimit, upperLimit, units } = props;

    const maxLimit = 20000;
    const minLimit = 0;
    const stepValue = 1;
    const rangeInputType = "range";
    const numberInputType = "number";

    const changeValueCheck = (newMinVal: number, newMaxVal: number) => {
        return (
            newMinVal < newMaxVal &&
            newMinVal >= minLimit &&
            newMaxVal >= minLimit &&
            newMinVal <= maxLimit &&
            newMaxVal <= maxLimit
        );
    };

    return (
        <DelimitedSection title={"Altitude range"}>
            <div id={"altitude-range-modifier"}>
                <div className={"range-slider"}>
                    <input
                        id={"min-slider"}
                        value={lowerLimit}
                        min={minLimit}
                        max={maxLimit}
                        step={stepValue}
                        type={rangeInputType}
                        onChange={(e) =>
                            changeValueCheck(e.target.valueAsNumber, upperLimit) &&
                            onChangeMinValue(e.target.valueAsNumber)
                        }
                    />
                    <input
                        id={"max-slider"}
                        value={upperLimit}
                        min={minLimit}
                        max={maxLimit}
                        step={stepValue}
                        type={rangeInputType}
                        onChange={(e) =>
                            changeValueCheck(lowerLimit, e.target.valueAsNumber) &&
                            onChangeMaxValue(e.target.valueAsNumber)
                        }
                    />
                </div>
                <div id={"range-slider-inputs"}>
                    <FlexBox alignItems={FlexAlignItems.CENTER} className={"altitudeRangeModifier"}>
                        <input
                            id={"input-min-slider"}
                            min={minLimit}
                            max={maxLimit}
                            type={numberInputType}
                            value={lowerLimit}
                            onChange={(e) =>
                                changeValueCheck(e.target.valueAsNumber, upperLimit) &&
                                onChangeMinValue(e.target.valueAsNumber)
                            }
                        />
                        <input
                            id={"input-max-slider"}
                            min={minLimit}
                            max={maxLimit}
                            type={numberInputType}
                            value={upperLimit}
                            onChange={(e) =>
                                changeValueCheck(lowerLimit, e.target.valueAsNumber) &&
                                onChangeMaxValue(e.target.valueAsNumber)
                            }
                        />
                        <select
                            name={"altitude-units-selector"}
                            id={"altitude-units-selector"}
                            onChange={(e) =>
                                (e.target.value === UnitsOfMeasurement.FEAT ||
                                    e.target.value === UnitsOfMeasurement.METRE) &&
                                onChangeUnits(e.target.value as UnitsOfMeasurement)
                            }
                            defaultValue={units}
                        >
                            <option disabled selected>
                                UOM
                            </option>
                            <option value={UnitsOfMeasurement.METRE}>Metre</option>
                            <option value={UnitsOfMeasurement.FEAT}>Feet</option>
                        </select>
                    </FlexBox>
                </div>
            </div>
        </DelimitedSection>
    );
};

export default AltitudeRangeModifier;
